import React from "react";
import Navbar from "../components/navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot ,  faPhone ,faEnvelope } from "@fortawesome/free-solid-svg-icons";
import Footer from "../components/Footer";
import ScrolltoTop from "../components/ScrolltoTop";
import UTMHandler from "../components/UTMHandler";
import AutoShowModal from "../components/AutoShowModal";



const Contact =()=> {
    return(
        <>
        <UTMHandler/>
         <div className="about-navbar">
        <Navbar/>
        </div>

 
<div className="contact-section">

        <div className="contact-details">

         <div className="address-container">
            <FontAwesomeIcon icon={faLocationDot} style={{color: '#164d55', width:'25px', height:'25px'}} />
            <div>
            <h6>Address</h6>
            <p><strong>Int2Cruises</strong> A division of Interzign Travel & Technology Pte Ltd
License No.- TA03440</p><br></br>
<p>435, Orchard Road, Level 11, Wisma Atria Singapore 238877</p>
            </div>
         </div>

         <div className="phone-container">
            <FontAwesomeIcon icon={faPhone} style={{color: '#164d55', width:'25px', height:'25px'}} />
            <div>
            <h6>Singapore</h6>
            <p><a href="tel:+6581237473" style={{ textDecoration: "none" , color:"#164d55", fontWeight: "bold" }}>+65-8123-7473</a></p>
            <h6>India</h6>
            <p><a href="tel:+919205030318" style={{ textDecoration: "none" , color:"#164d55", fontWeight: "bold" }}>+91-9205030318</a></p>
            </div>
         </div>

         <div className="email-container">
            <FontAwesomeIcon icon={faEnvelope} style={{color: '#164d55', width:'25px', height:'25px'}} />
            <div>
            <h6>Email</h6>
            <p><a href="mailto:booking@int2cruises.com" style={{ textDecoration: "none", color: "#164D55", fontWeight: "bold" }}>booking@int2cruises.com</a></p>
            </div>
         </div>

         {/* <div className="timing-container">
            <FontAwesomeIcon icon={faClock} style={{color: '#ffffff', width:'20px', height:'25px'}} />
            <div>
            <h6>Business Hours</h6>
            <p>Mon- Fri: 9:00 - 20:00<br></br>
            Saturdays: 9:30 - 18:00</p>
            </div>
         </div> */}

      </div>


         <div style={{ width: "80%", height: "550px", overflow: "hidden", borderRadius: "10px" }} className="location-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7855011207644!2d103.83068927472452!3d1.3037147986839073!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da198df8c29149%3A0xf771a17ac165c09b!2sWisma%20Atria!5e0!3m2!1sen!2sin!4v1747824830975!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Wisma Atria Map"
      ></iframe>
    </div>
  
  </div>

  <ScrolltoTop/>
  <AutoShowModal/>
  <Footer/>

        </>
    );
}

export default Contact;